import { Badge } from '@/components/ui/badge.js';
import { PrismaEnums, SessionStatusToLabel } from '@airreading/common';
import clsx from 'clsx';

interface SessionStatusBadgeProps {
  status: PrismaEnums.SessionStatus;
}

const StatusColorMap = {
  [PrismaEnums.SessionStatus.scheduled]: 'bg-slate-600',
  [PrismaEnums.SessionStatus.completed]: 'bg-green-600',
  [PrismaEnums.SessionStatus.in_progress]: 'bg-blue-600',
  [PrismaEnums.SessionStatus.cancelled]: 'bg-red-600',
  [PrismaEnums.SessionStatus.archived]: 'bg-cyan-600',
};

export const SessionStatusBadge = ({ status }: SessionStatusBadgeProps) => {
  return <Badge className={clsx(StatusColorMap[status])}>{SessionStatusToLabel[status]}</Badge>;
};
